"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Knowledge = void 0;
var Fulfilment_1 = require("./Fulfilment");
var User_1 = require("./User");
var ApiKey_1 = require("./ApiKey");
var Behaviour_1 = require("./Behaviour");
var Statement_1 = require("./Statement");
var Intent_1 = require("./Intent");
var Code_1 = require("./Code");
var Role_1 = require("./Role");
var SkillProvision_1 = require("./SkillProvision");
var Skill_1 = require("./Skill");
var Tenant_1 = require("./Tenant");
var Prompt_1 = require("./Prompt");
var Identity_1 = require("./Identity");
var Edge_1 = require("./Edge");
var Knowledge = /** @class */ (function (_super) {
    __extends(Knowledge, _super);
    function Knowledge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Knowledge";
        _this.users = function (limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("limit", limit);
            var name2 = registry.register("offset", offset);
            var name3 = registry.register("orderBy", orderBy);
            var name4 = registry.register("order", order);
            var entity = new User_1.User();
            config(entity);
            return "users(limit:" + name1 + ", offset:" + name2 + ", orderBy:" + name3 + ", order:" + name4 + "){" + entity.render(registry) + "}";
        }); };
        _this.user = function (userId, config) { return _this.push(function (registry) {
            var name1 = registry.register("userId", userId);
            var entity = new User_1.User();
            config(entity);
            return "user(userId:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.apiKeys = function (limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("limit", limit);
            var name2 = registry.register("offset", offset);
            var name3 = registry.register("orderBy", orderBy);
            var name4 = registry.register("order", order);
            var entity = new ApiKey_1.ApiKey();
            config(entity);
            return "apiKeys(limit:" + name1 + ", offset:" + name2 + ", orderBy:" + name3 + ", order:" + name4 + "){" + entity.render(registry) + "}";
        }); };
        _this.apiKey = function (apiKeyId, config) { return _this.push(function (registry) {
            var name1 = registry.register("apiKeyId", apiKeyId);
            var entity = new ApiKey_1.ApiKey();
            config(entity);
            return "apiKey(apiKeyId:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.roles = function (tenantId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Role_1.Role();
            config(entity);
            return "roles(tenantId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.role = function (tenantId, roleId, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var name2 = registry.register("roleId", roleId);
            var entity = new Role_1.Role();
            config(entity);
            return "role(tenantId:" + name1 + ", roleId:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.tenants = function (limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("limit", limit);
            var name2 = registry.register("offset", offset);
            var name3 = registry.register("orderBy", orderBy);
            var name4 = registry.register("order", order);
            var entity = new Tenant_1.Tenant();
            config(entity);
            return "tenants(limit:" + name1 + ", offset:" + name2 + ", orderBy:" + name3 + ", order:" + name4 + "){" + entity.render(registry) + "}";
        }); };
        _this.tenant = function (tenantId, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var entity = new Tenant_1.Tenant();
            config(entity);
            return "tenant(tenantId:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.identities = function (limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("limit", limit);
            var name2 = registry.register("offset", offset);
            var name3 = registry.register("orderBy", orderBy);
            var name4 = registry.register("order", order);
            var entity = new Identity_1.Identity();
            config(entity);
            return "identities(limit:" + name1 + ", offset:" + name2 + ", orderBy:" + name3 + ", order:" + name4 + "){" + entity.render(registry) + "}";
        }); };
        _this.identity = function (identityId, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var entity = new Identity_1.Identity();
            config(entity);
            return "identity(identityId:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.intents = function (identityId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Intent_1.Intent();
            config(entity);
            return "intents(identityId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.intent = function (identityId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("reference", reference);
            var entity = new Intent_1.Intent();
            config(entity);
            return "intent(identityId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.prompts = function (identityId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Prompt_1.Prompt();
            config(entity);
            return "prompts(identityId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.prompt = function (identityId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("reference", reference);
            var entity = new Prompt_1.Prompt();
            config(entity);
            return "prompt(identityId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.fulfilments = function (identityId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Fulfilment_1.Fulfilment();
            config(entity);
            return "fulfilments(identityId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.fulfilment = function (identityId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("reference", reference);
            var entity = new Fulfilment_1.Fulfilment();
            config(entity);
            return "fulfilment(identityId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.statements = function (identityId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Statement_1.Statement();
            config(entity);
            return "statements(identityId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.statement = function (identityId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("reference", reference);
            var entity = new Statement_1.Statement();
            config(entity);
            return "statement(identityId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.codes = function (identityId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Code_1.Code();
            config(entity);
            return "codes(identityId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.code = function (identityId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("reference", reference);
            var entity = new Code_1.Code();
            config(entity);
            return "code(identityId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.behaviours = function (identityId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Behaviour_1.Behaviour();
            config(entity);
            return "behaviours(identityId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.behaviour = function (identityId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("identityId", identityId);
            var name2 = registry.register("reference", reference);
            var entity = new Behaviour_1.Behaviour();
            config(entity);
            return "behaviour(identityId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.edges = function (source, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("source", source);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Edge_1.Edge();
            config(entity);
            return "edges(source:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.edge = function (source, edgeId, config) { return _this.push(function (registry) {
            var name1 = registry.register("source", source);
            var name2 = registry.register("edgeId", edgeId);
            var entity = new Edge_1.Edge();
            config(entity);
            return "edge(source:" + name1 + ", edgeId:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.skills = function (tenantId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new Skill_1.Skill();
            config(entity);
            return "skills(tenantId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.skill = function (tenantId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var name2 = registry.register("reference", reference);
            var entity = new Skill_1.Skill();
            config(entity);
            return "skill(tenantId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.skillProvisions = function (tenantId, limit, offset, orderBy, order, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var name2 = registry.register("limit", limit);
            var name3 = registry.register("offset", offset);
            var name4 = registry.register("orderBy", orderBy);
            var name5 = registry.register("order", order);
            var entity = new SkillProvision_1.SkillProvision();
            config(entity);
            return "skillProvisions(tenantId:" + name1 + ", limit:" + name2 + ", offset:" + name3 + ", orderBy:" + name4 + ", order:" + name5 + "){" + entity.render(registry) + "}";
        }); };
        _this.skillProvision = function (tenantId, reference, config) { return _this.push(function (registry) {
            var name1 = registry.register("tenantId", tenantId);
            var name2 = registry.register("reference", reference);
            var entity = new SkillProvision_1.SkillProvision();
            config(entity);
            return "skillProvision(tenantId:" + name1 + ", reference:" + name2 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Knowledge;
}(Array));
exports.Knowledge = Knowledge;
//# sourceMappingURL=Knowledge.js.map